(ns quuppa.qsm.users.view
  (:require [clojure.string :as str]
            [komponentit.input :as input]
            [quuppa.peweb.query :as q]
            [quuppa.qsm.events :as e]
            [quuppa.qsm.permissions :as permissions]
            [quuppa.qsm.permissions-access :as permissions-access]
            [quuppa.qsm.projects.events :as pe]
            [quuppa.qsm.site.events :as se]
            [quuppa.qsm.view :as qsm-view]
            [quuppa.ui.breadcrumbs :as b]
            [re-frame.core :as rf]
            [quuppa.qsm.users.events :as ue]
            [quuppa.qsm.users.subs]
            [quuppa.qsm.subs :as qsm-subs]
            [quuppa.qsm.projects.subs :as ps]
            [quuppa.qsm.site.subs :as ss]
            [quuppa.ui.button :as button]
            [quuppa.ui.layout :as layout]
            [reitit.frontend.easy :as rfe]
            [quuppa.qsm.not-found :as not-found]))

(defn add-user-form []
  (let [qsm-users @(rf/subscribe [:qsm/qsm-users])
        odoo-emails (into #{}
                          (keep (fn [[_id user]]
                                  (when (= "odoo" (:idp_provider user))
                                    (:email user)))
                                (if (= :loading qsm-users) [] qsm-users)))
        form-data @(rf/subscribe [:qsm/add-user-form-data])
        failure-data @(rf/subscribe [:qsm/add-user-failure-data])
        current-user @(rf/subscribe [::qsm-subs/user])
        current-user-role (permissions-access/get-user-role current-user)
        roles-options (permissions-access/user-roles-options current-user-role)]
    [layout/sidebar
     [layout/sidebar-header
      {:title "Add user"
       :on-close #(rf/dispatch [:qsm/remove-admin-sidebar])}]

     [layout/sidebar-content
      [:div.mb-3
       [:label "Email:"]
       [:input.form-control
        {:value (:email form-data)
         :on-change #(rf/dispatch [:qsm/add-user-form-data :email (.. % -target -value)])}]
       [:div.alert.alert-light.p-0 "An invitation email will be sent to the email address after creating the user."]]

      [:div.mb-3
       [:label "Role: "]
       [input/select
        {:class "form-select"
         :on-change #(rf/dispatch [:qsm/add-user-form-data :role %])
         :value (:role form-data)
         :value-fn #(str %)
         :options roles-options}]]

      [:div.d-flex.justify-content-between
       [:button.btn.btn-primary
        {:disabled (let [email (:email form-data)]
                     (if email
                       (or (contains? odoo-emails (-> email str/trim str/lower-case)) ;; Email already in use
                           (not (str/includes? email "@"))  ;; Email doesn't contain the "@" character
                           (let [[mailbox domain] (str/split email "@")]
                             (or (empty? domain)            ;; Check mailbox and domain
                                 (empty? mailbox))))
                       true))
         :type "button"
         :on-click (fn [_]
                     (rf/dispatch [:qsm/add-user form-data]))}
        "Add"]]

      (when failure-data
        [:div.p-4.alert.alert-warning.text-center
         [:label (str (:err-msg failure-data))]
         [:label "Please check that the email is correct."]])]]))

(defn user-exists? [qsm-users email]
  (let [existing-users-emails (->> qsm-users
                                   (map (fn [[id qsm-user]]
                                          (:email qsm-user)))
                                   (set))]
    (contains? existing-users-emails email)))

(defn assign-user! [qsm-users form-data]
  (let [success-handler (if (:site-id form-data)
                          :qsm/assign-user-to-site
                          :qsm/assign-user-to-project)]
    (if (user-exists? qsm-users (:email form-data))
      (do
        (if (:site-id form-data)
          (rf/dispatch [:qsm/assign-user-to-site form-data])
          (rf/dispatch [:qsm/assign-user-to-project form-data])))
      (do
        (rf/dispatch [:qsm/add-user-and-resource-role {:role "member"
                                                       :email (:email form-data)}
                      success-handler
                      form-data])))))

(defn roles-options [site-entity project-entity]
  (let [current-user @(rf/subscribe [::qsm-subs/user])
        current-user-role (permissions-access/get-user-role current-user)
        current-user-resource-role (if site-entity
                                     (:resource-role site-entity)
                                     (:resource-role project-entity))]
    (if (= current-user-role "member")
      (permissions-access/user-roles-options current-user-resource-role)
      (permissions-access/user-roles-options current-user-role))))

(defn assign-user-form [project-entity site-entity]
  (let [qsm-users @(rf/subscribe [:qsm/qsm-users])
        resource-users @(rf/subscribe [:qsm/resource-users])
        resource-user-emails (->> resource-users
                                  (map (fn [[id resource-user]]
                                         (:email resource-user)))
                                  (set))
        form-data @(rf/subscribe [:qsm/assign-user-form-data])
        roles-options (roles-options site-entity project-entity)]
    [layout/sidebar
     [layout/sidebar-header
      {:title "Assign user"
       :on-close #(rf/dispatch [:qsm/remove-admin-sidebar])}]

     [layout/sidebar-content
      [:div.mb-3
       [:label "Email:"]
       [:input.form-control
        {:value (:email form-data)
         :on-change #(rf/dispatch [:qsm/assign-user-form-data :email (.. % -target -value)])}]
       [:div.alert.alert-light.p-0 "An invitation email will be sent to the email address after creating the user."]]

      [:div.mb-3
       [:label "Role: "]
       [input/select
        {:class "form-select"
         :on-change #(rf/dispatch [:qsm/assign-user-form-data :role %])
         :value (:role form-data)
         :value-fn #(str %)
         :options roles-options}]]

      [:div.d-flex.justify-content-between
       [:button.btn.btn-primary
        {:type "button"
         :disabled (let [email (:email form-data)]
                     (if email
                       (or (contains? resource-user-emails (-> email str/trim str/lower-case)) ;; Email already in use
                           (not (str/includes? email "@"))  ;; Email doesn't contain the "@" character
                           (let [[mailbox domain] (str/split email "@")]
                             (or (empty? domain)            ;; Check mailbox and domain
                                 (empty? mailbox))))
                       true))
         :on-click (fn [_]
                     (assign-user! qsm-users form-data))}
        "Add"]]]]))

(defn edit-user-form []
  (let [form-data @(rf/subscribe [:qsm/edit-user-form-data])
        resource-view? (or (:project-id form-data)
                           (:site-id form-data))
        user-id (:user-id form-data)
        role-id (:role-id form-data)
        project-id-string (str (:project-id form-data))
        site-id-string (str (:site-id form-data))
        project-entity @(rf/subscribe [::ps/project (str (:project-id form-data))])
        site-entity (when (:site-id form-data)
                      @(rf/subscribe [::ss/site project-id-string site-id-string]))
        roles-options (roles-options site-entity project-entity)]
    [layout/sidebar
     [layout/sidebar-header
      {:title "Edit user"
       :on-close #(rf/dispatch [:qsm/remove-admin-sidebar])}]

     [layout/sidebar-content

      [:div.mb-3
       [:label "Role: "]
       [input/select
        {:class "form-select"
         :on-change #(rf/dispatch [:qsm/edit-user-form-data :role %])
         :value (:role form-data)
         :value-fn #(str %)
         :options roles-options}]]

      [:div.d-flex.justify-content-between
       [:button.btn.btn-primary
        {:disabled false
         :type "button"
         :on-click (fn [_]
                     (if resource-view?
                       (rf/dispatch [:qsm/change-user-resource-role
                                     {:role-id role-id
                                      :role (:role form-data)
                                      :project-id (:project-id form-data)
                                      :site-id (:site-id form-data)}])
                       (rf/dispatch [:qsm/change-user-role user-id (:role form-data)])))}
        "Save"]]]]))

(defn user-tools [init-edit-user-data delete-user!]
  [:<>
   [button/button
    {:start-icon :pencil-fill
     :class "mr-3"
     :on-click (fn [_]
                 (rf/dispatch [:qsm/admin-sidebar {}])
                 (rf/dispatch [:qsm/init-edit-user-form-data init-edit-user-data]))}
    "Edit"]

   [button/button
    {:start-icon :trash-fill
     :on-click delete-user!}
    "Delete"]])

(defn user-row [{:keys [user user-role show-user-tools? init-edit-user-data delete-user!]}]
  [:tr
   [:td (:idp_provider user)]
   [:td (:email user)]
   [:td.p-1 user-role]
   [:td.text-center.align-middle
    (when show-user-tools?
      [user-tools init-edit-user-data delete-user!])]])

(defn user-settings []
  (let [{:keys [view project site]} @(rf/subscribe [:nav/match :parameters :query])
        sidebar @(rf/subscribe [:qsm/admin-sidebar])
        add-user-form-data @(rf/subscribe [:qsm/add-user-form-data])
        edit-user-form-data @(rf/subscribe [:qsm/edit-user-form-data])
        assign-user-form-data @(rf/subscribe [:qsm/assign-user-form-data])
        project-entity @(rf/subscribe [::ps/project project])
        site-entity (when site
                      @(rf/subscribe [::ss/site project site]))
        current-user @(rf/subscribe [::qsm-subs/user])
        current-user-qsm-role (permissions-access/get-user-role current-user)
        current-role-level (if (= "member" current-user-qsm-role)
                             (permissions-access/get-role-level (or (:resource-role site-entity) (:resource-role project-entity)))
                             (permissions-access/get-role-level current-user-qsm-role))
        qsm-users @(rf/subscribe [:qsm/qsm-users])
        resource-users @(rf/subscribe [:qsm/resource-users])
        project-view? (= view "project")
        site-view? (= view "site")
        resource-user-management? (or site-view? project-view?)
        user-button-title (if resource-user-management?
                            "Assign new user"
                            "Add new user")
        users (if resource-user-management?
                resource-users
                qsm-users)
        project-id (when project
                     (uuid project))
        site-id (when site
                  (uuid site))]
    [:<>
     (when resource-user-management?
       [qsm-view/navbar-content
        [b/breadcrumbs
         {:class "my-0 pl-2"}
         [b/breadcrumb-item [:a
                             {:href (if site
                                      (rfe/href :project {:project-id project-id})
                                      (rfe/href :projects))}
                             (if site
                               (:name project-entity)
                               "Projects")]]
         [b/breadcrumb-item [:a
                             {:href (if site
                                      (rfe/href :site {:project-id project-id
                                                       :site-id site-id})
                                      (rfe/href :project {:project-id project-id}))}
                             (if site
                               (:name site-entity)
                               (:name project-entity))]]
         [b/breadcrumb-current "User management"]]])

     [layout/view-content
      {:sidebar-open sidebar}
      [layout/view-header
       {:title "User role management"
        :actions [button/button
                  {:variant "primary"
                   :start-icon :plus
                   :on-click (fn [_]
                               (rf/dispatch [:qsm/admin-sidebar {}])
                               (cond
                                 project-view? (rf/dispatch [:qsm/init-assign-user-form-data {:role "member"
                                                                                              :resource-id (:resource-id project-entity)
                                                                                              :project-id project-id}])
                                 site-view? (rf/dispatch [:qsm/init-assign-user-form-data {:role "member"
                                                                                           :site-resource-id (:resource-id site-entity)
                                                                                           :project-resource-id (:resource-id project-entity)
                                                                                           :project-id project-id
                                                                                           :site-id site-id}])
                                 :else (rf/dispatch [:qsm/add-user-form-data :role "member"])))}
                  user-button-title]}]
      (cond
        (= :loading users)
        [:h4 "LOADING..."]

        (and (not (= :loading users))
             (not (seq users)))
        [:h4 "No users available"]

        :default
        [:table.table.table-striped.table-bordered
         [:thead
          [:tr.bg-dark.text-white
           [:th "Identity Provider"]
           [:th "Email"]
           [:th "Roles"]
           [:th]]]
         [:tbody
          (doall
            (for [[id user] users
                  :let [user-role (:role user)
                        role-level (permissions-access/get-role-level user-role)
                        show-user-tools? (if (= current-user-qsm-role "member")
                                           (and (not (= (:email user) (:email current-user)))
                                                (>= current-role-level role-level)
                                                (not= user-role "owner"))
                                           (and (not (= (:email user) (:email current-user)))
                                                (>= current-role-level role-level)))

                        init-edit-user-data (if (or project-id site-id)
                                              {:user-id    (:id user)
                                               :role-id    (:role_id user)
                                               :project-id project-id
                                               :site-id    site-id
                                               :role       user-role}
                                              {:user-id (:id user)
                                               :role    user-role})
                        delete-user! (if (or project-id site-id)
                                       #(when (js/confirm "Remove user?")
                                          (rf/dispatch [:qsm/remove-resource-role {:role-id    (:role_id user)
                                                                                   :project-id project-id
                                                                                   :site-id    site-id}]))
                                       #(when (js/confirm "Delete user?")
                                          (rf/dispatch [:qsm/delete-user (:id user)])))]]
              ^{:key id}
              [user-row {:show-user-tools?    show-user-tools?
                         :init-edit-user-data init-edit-user-data
                         :delete-user!        delete-user!
                         :user                user
                         :user-role           user-role}]))]])]

     (when add-user-form-data
       [add-user-form])

     (when assign-user-form-data
       [assign-user-form project-entity site-entity])

     (when edit-user-form-data
       [edit-user-form])]))

(defn users-page []
  (let [{:keys [project site]} @(rf/subscribe [:nav/match :parameters :query])
        project-entity @(rf/subscribe [::ps/project project])
        site-entity (when site
                      @(rf/subscribe [::ss/site project site]))
        resource-entity (if site
                          site-entity
                          project-entity)
        manage-permissions? (or (permissions/has-manage-permission?)
                               (permissions/has-manage-permission-to-resource? resource-entity))]
  [layout/section
   (if manage-permissions?
     [user-settings]
     [not-found/not-found-view {:text "The view not found"}])]))

(def controller
  {:id :users
   :parameters {:query [:project :site :view]}
   :start (fn [params]
            (let [project (some-> params :query :project)
                  site (some-> params :query :site)]
              (rf/dispatch [:qsm/load-users-and-roles])
              (q/execute e/authorized-qpes {})
              (q/execute pe/projects-query {})

              (when (and project (not site))
                (rf/dispatch [:qsm/get-resource-users {:project-id (parse-uuid project)}]))
              (when site
                (rf/dispatch [:qsm/get-resource-users {:project-id (parse-uuid project)
                                                       :site-id (parse-uuid site)}])
                (q/execute se/project-sites-query {:project-id (parse-uuid project)}))))
   :stop (fn []
           (rf/dispatch [::ue/users-view-stop]))
   :subscriptions (fn [_]
                    [[:qsm/qsm-users {}]])})


